import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';

import { LionTranslate, lionSelectors } from '@rosetta/react-lion';
import { isCatalystAdmin, isCatalyst, ojibweLicenseFilter, hasOjibweProducts } from '../../../helpers/productConfigHelper';
import { launchpadSelectors, launchpadActions } from '../reducer/launchpad-reducer';
import {
  appMainBackground,
  appTextColor,
  lightBlueColor,
  white,
  defaultBoxShadow,
  whiteHoverColor,
  noEntitlementsGray
} from '../../../styles/colors';
import { hiResBgImage } from '../../../styles/mixins';
import leftArrowDarkSvg from '../../../assets/images/arrow-left-darkgrey.svg';
import rightArrow from '../../../assets/images/arrow-right.svg';
import rightArrowHover from '../../../assets/images/arrow-right-hover.svg';
import hiResAebIcon from '../../../assets/images/icon-default.svg';
import loResAebIcon from '../../../assets/images/icon-default.svg';
import adminToolsIcon from '../../../assets/images/admin-tools.svg';
import noProductIcon from '../../../assets/images/icon-content-file.svg';
import { appSelectors } from '../../app/reducer/app-reducer';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isUserCatalystPreTestOnly } from '../../app/util/user-helper';
import { authSelectors } from '@rosetta/react-auth/dist/index';
import { isMobile as isMobileDetected } from 'react-device-detect';

let isRtl = false;

const ChooserWrapper = styled.div((props) => {
  let style = {
    paddingBottom: '10px',
    display: !props.isMobile ? 'table-cell' : 'block',
    width: !props.isMobile ? '530px' : '100%'
  };
  return style;
});

const ChooserBox = styled.div((props) => {
  let style = {
    backgroundColor: !props.isMobile ? white : appMainBackground,
    fontFamily: 'inherit',
    textAlign: 'center',
    borderRadius: '4px',
    boxShadow: !props.isMobile ? defaultBoxShadow : 'none',
    width: !props.isMobile ? '530px' : '100%'
  };
  return style;
});

const ChooserHeaderMobile = styled.div(() => {
  let style = {
    padding: '10px 0'
  };
  return style;
});

const ChooserHeader = styled.div(() => {
  let style = {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: '10px 20px',
    textAlign: 'left',
    width: '156px'
  };
  return style;
});

const ChooserTitle = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '18px' : '14px',
    textAlign: 'left',
    fontWeight: '500',
    display: 'table-cell'
  };
  return style;
});

const MyProductsWrapper = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'table-cell' : 'block'
  };
  return style;
});

const LaunchContentContainerDiv = styled.div((props) => {
  let style = {
    // this with the anchor style is because the "no entitlements"
    //  string has a link built into it
    '& a': {
      color: lightBlueColor,
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline'
      }
    }
  };
  if (!props.hasEntitlements) {
    style.textAlign = 'center';
    style.padding = '190px 20px 20px';
    style.backgroundImage = 'url(' + noProductIcon + ')';
    style.backgroundPosition = 'center 10px';
    style.backgroundRepeat = 'no-repeat';
    style.backgroundColor = appMainBackground;
    style.margin = '-20px';
    style.width = '600px';
  }
  return style;
});

const NoEntitlementsHeader = styled.div({
  fontSize: '24px',
  fontWeight: 'bold',
  lineHeight: '30px',
  marginBottom: '20px',
  color: noEntitlementsGray
});

const NoEntitlementsBody = styled.div({
  fontSize: '18px',
  lineHeight: '24px',
  // there are no RTL translations so:
  direction: 'ltr',
  color: noEntitlementsGray
});

const LaunchList = styled.ul(() => {
  let style = {
    listStyle: 'none',
    paddingLeft: '0px',
    width: '100%'
  };
  return style;
});

const Logo = styled.div((props) => {
  const logoHeight = props.hasOneProduct ? '60px' : '40px';
  const logoWidth = props.hasOneProduct ? '60px' : '40px';

  let style = {
    position: 'absolute',
    backgroundPosition: '0px 0px',
    backgroundRepeat: 'no-repeat',
    ...hiResBgImage(
      props.isAdmin ? adminToolsIcon : loResAebIcon,
      props.isAdmin ? adminToolsIcon : hiResAebIcon,
      logoWidth,
      logoHeight
    ),
    height: logoHeight,
    width: logoWidth,
    top: props.hasOneProduct ? '35px' : '12px',
    ':hover': {
      backgroundColor: whiteHoverColor,
      cursor: 'pointer'
    }
  };
  if (isRtl) {
    style.right = '20px';
    style.left = 'auto';
  } else {
    style.right = 'auto';
    style.left = '20px';
  }
  return style;
});

const LaunchListItem = styled.li((props) => {
  let style = {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '12px 12px',
    borderBottom: !props.isMobile ? '1px solid' + appMainBackground : 'none',
    color: appTextColor,
    fontSize: '14px',
    height: props.hasOneProduct ? '130px' : '65px',
    position: 'relative',
    fontFamily: 'inherit',
    fontWeight: '400',
    textAlign: 'left',
    letterSpacing: '1px',
    width: !props.isMobile ? '347px' : '100%',
    outline: 'none',
    paddingTop: props.hasOneProduct ? '43px' : '10px',
    ':hover': {
      color: lightBlueColor,
      cursor: 'pointer'
    },
    ':last-child': {
      borderBottom: 'none'
    }
  };
  if (isRtl) {
    style.backgroundImage = 'url(' + leftArrowDarkSvg + ')';
    style.backgroundPosition = 21 + 'px 47px';
    style.paddingRight = '100px';
    style.paddingLeft = '20px';
  } else {
    style.backgroundImage = 'url(' + rightArrow + ')';
    style.backgroundPosition = '325px center';
    style.paddingRight = '20px';
    style.paddingLeft = props.hasOneProduct ? '91px' : '76px';
    style.backgroundSize = '8px 12px';
    style[':hover'].backgroundImage = 'url(' + rightArrowHover + ')';
  }

  if (props.isMobile) {
    style.backgroundColor = white;
    style.marginBottom = '10px';
    style.borderRadius = '6px';
    style.boxShadow = defaultBoxShadow;
    style.backgroundPosition = '96% center';
    style.marginRight = '16px';
  }
  return style;
});

const ProductName = styled.div(() => {
  let style = {
    marginTop: '12px'
  };
  if (isRtl) {
    style.float = 'right';
  } else {
    style.float = 'left';
  }
  return style;
});

//*********************************************
export class Chooser extends PureComponent {
  render = () => {
    if (!this.props.lionLoaded || !this.props.userInfo) {
      return null;
    }

    isRtl = this.props.isInterfaceRtl;

    let hasCatalyst = false;
    let launchContentContainer = null;
    let myProductsTitle = null;
    let myProductsTitleMobile = null;
    const isMobile = isMobileDetected;
    const catalystPreTestOnly = isUserCatalystPreTestOnly(this.props.userInfo);
    const hasNoAccess = !this.props.recommendations || this.props.recommendations.length === 0 || catalystPreTestOnly;

    if (this.props.recommendationsLoaded && hasNoAccess) {
      if (catalystPreTestOnly) {
        launchContentContainer = (
          <LaunchContentContainerDiv hasEntitlements={false}>
            <NoEntitlementsHeader data-qa="CatalystPreTestOnlyHeader">
              <LionTranslate lionkey="pretest_job_candidate_thanks" />
            </NoEntitlementsHeader>
            <NoEntitlementsBody>
              <LionTranslate lionkey="pretest_job_candidate_results_saved" />
            </NoEntitlementsBody>
          </LaunchContentContainerDiv>
        );
      } else {
        const localizedNoEntitlementsMessage = this.props.getLionTranslatedString('no_entitlements_message');
        launchContentContainer = (
          <LaunchContentContainerDiv hasEntitlements={false}>
            <NoEntitlementsHeader data-qa="NoEntitlementsHeader">
              <LionTranslate lionkey="no_entitlements_heading" />
            </NoEntitlementsHeader>
            <NoEntitlementsBody dangerouslySetInnerHTML={{ __html: localizedNoEntitlementsMessage }} />
          </LaunchContentContainerDiv>
        );
      }
    } else {
      let productButtons = null;

      if (this.props.recommendations && this.props.recommendations.length > 0) {
        this.props.recommendations.forEach((recommendation) => {
          if (isCatalyst(recommendation.product_id) || isCatalystAdmin(recommendation.product_id)) {
            hasCatalyst = true;
          }
        });

        if (hasCatalyst) {
          if (isMobile) {
            myProductsTitleMobile = (
              <ChooserHeaderMobile>
                <ChooserTitle isMobile={isMobile}>
                  <LionTranslate lionkey="my_products" />
                </ChooserTitle>
              </ChooserHeaderMobile>
            );
          } else {
            myProductsTitle = (
              <ChooserHeader>
                <ChooserTitle>
                  <LionTranslate lionkey="my_products" />
                </ChooserTitle>
              </ChooserHeader>
            );
          }
        }
        productButtons = this.props.recommendations.map((recommendation) => (
          <LaunchListItem
            hasOneProduct={this.props.recommendations.length === 1}
            data-qa="Recommendation"
            key={recommendation.product_id}
            onClick={() => this.props.launchRecommendation(recommendation, isMobile)}
            isMobile={isMobile}
          >
            <Logo
              isAdmin={isCatalystAdmin(recommendation.product_id)}
              hasOneProduct={this.props.recommendations.length === 1}
            />
            <ProductName data-qa={'ProductName-' + recommendation.product_name.replace(/ /g, '')}>
              {recommendation.product_name}
            </ProductName>
          </LaunchListItem>
        ));
      }
      launchContentContainer = (
        <LaunchContentContainerDiv hasEntitlements={true}>
          <LaunchList data-qa="LaunchList">
            {productButtons}
          </LaunchList>
        </LaunchContentContainerDiv>
      );
    }
    return (
      <ChooserWrapper isMobile={isMobile}>
        {myProductsTitleMobile}
        <ChooserBox isMobile={isMobile}>
          {myProductsTitle}
          <MyProductsWrapper data-qa="launch-pad" isMobile={isMobile}>
            {launchContentContainer}
          </MyProductsWrapper>
        </ChooserBox>
      </ChooserWrapper>
    );
  };
}

Chooser.propTypes = {};

const mapStateToProps = (state, ownprops) => {
  const rawRecommendations = launchpadSelectors.recommendations(state);
  const recommendations = hasOjibweProducts(rawRecommendations)
    ? ojibweLicenseFilter(rawRecommendations)
    : rawRecommendations;
  return {
    isInterfaceRtl: appSelectors.isInterfaceRtl(state),
    lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
    getLionTranslatedString: (key) => lionSelectors.getLionTranslatedString(state, key),
    recommendationsLoaded: launchpadSelectors.recommendationsLoaded(state),
    recommendations,
    userInfo: authSelectors.userInfo(state),
  };
};

const wrapActions = {
  launchRecommendation: launchpadActions.launchRecommendation
};
export const ChooserContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(Chooser));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/Chooser.jsx